import { Alert, Box, Card, Chip, Divider, Link } from "@mui/material";
import localize from "../../../common/localize";
import {
  getMovementTypeColor,
  getMovementTypeName,
} from "../../../common/EntitiesManagement";
import { GetDateInDDMMYYYYFormat } from "../../../common/utils";

export default function InventoryMovementItem({ item, onOpen, showQuantity }) {
  return (
    <Card
      variant="outlined"
      style={{ borderRadius: "5px" }}
      className="w-full p-2 flex flex-col gap-2"
    >
      <Box className="w-full flex gap-2 justify-between items-center">
        <Box className="flex flex-col gap-2">
          <label className="field_title_text">
            <b>{localize.code}: </b>
            <Link
              color="primary"
              underline="always"
              href="#"
              onClick={onOpen}
            >{`${item.Code}`}</Link>
          </label>

          {item.EventRelated && (
            <label className="field_title_text">
              <b>{localize.service_order}: </b>
              <Link
                color="primary"
                underline="always"
                href="#"
                onClick={() => {
                  window.open(
                    `/events/detail/${item.EventRelated.Id}`,
                    "_blank"
                  );
                }}
              >{`${item.EventRelated.Code}`}</Link>
            </label>
          )}
        </Box>

        <Chip
          className="chipContainer"
          style={{
            backgroundColor: getMovementTypeColor(
              item.MovementType.MovementType
            ),
            color: "white",
            borderColor: getMovementTypeColor(item.MovementType.MovementType),
          }}
          label={getMovementTypeName(item.MovementType.MovementType)}
        />
      </Box>

      <Divider />

      <Box className="flex gap-2 justify-between">
        <Box className="two_columns_grid">
          {showQuantity && item.Quantity && (
            <label className="field_title_text">
              <b>{localize.quantity}:</b>
            </label>
          )}

          {showQuantity && item.Quantity && (
            <label className="field_title_text">{item.Quantity}</label>
          )}

          <label className="field_title_text">
            <b>{localize.movement_date}:</b>
          </label>
          <label className="field_title_text">
            {GetDateInDDMMYYYYFormat(new Date(item.MovementDate))}
          </label>
          <label className="field_title_text">
            <b>{localize.movement_type}:</b>
          </label>
          <label className="field_title_text">{item.MovementType.Name}</label>

          {item.Warehouse && (
            <label className="field_title_text">
              <b>{localize.warehouse}:</b>
            </label>
          )}
          {item.Warehouse && (
            <label className="field_title_text">{item.Warehouse.Name}</label>
          )}

          <label className="field_title_text">
            <b>{localize.modification_date}:</b>
          </label>
          <label className="field_title_text">
            {new Date(item.ModificationDate).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </label>
          <label className="field_title_text">
            <b>{localize.modified_by}:</b>
          </label>
          <label className="field_title_text">{item.CreatedBy}</label>
        </Box>
      </Box>

      {item.Observation && (
        <Alert severity="info" className="w-full">
          <label className="text-xs">
            <b>{localize.observations}: </b>
            {item.Observation}
          </label>
        </Alert>
      )}
    </Card>
  );
}
